module.exports = function(){
  if(document.querySelector('#billing_email') && document.querySelector('.newsletter-email')) {
    var billing_email = document.querySelector('#billing_email');
    var newsletter_email = document.querySelector('.newsletter-email input[type="text"]');
    var email_value = billing_email.getAttribute('value');

    newsletter_email.setAttribute('value', email_value);
  }

}
